export default {
    list: {
        method: 'get',
        url: '/roles'
    },
    detail: {
        method: 'get',
        url: '/roles/:id'
    },
    add: {
        method: 'post',
        url: '/roles'
    },
    edit: {
        method: 'patch',
        url: '/roles/:id'
    },
    delete: {
        method: 'delete',
        url: '/roles/:id'
    },
    menu: {
        method: 'get',
        url: '/roles/:id/menus'
    },
    setMenu: {
        method: 'post',
        url: '/roles/:id/menus'
    },
};



// WEBPACK FOOTER //
// ./src/api/role.js